var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisable = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Disable",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_edit",
    transform: "translate(1.5, 1.5)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C6.46250001,15 5.48750031,14.8029999 4.57500029,14.4089999 C3.66250026,14.0149999 2.86875013,13.4807506 2.19375014,12.8062506 C1.51875016,12.1312506 0.98450008,11.3374997 0.59100008,10.4249997 C0.19750008,9.51249969 0.000499999995,8.53749999 0,7.5 C0,6.46250001 0.197000071,5.48750031 0.59100008,4.57500029 C0.985000089,3.66250026 1.51925012,2.86875013 2.19375014,2.19375014 C2.86875013,1.51875016 3.66250026,0.98450008 4.57500029,0.59100008 C5.48750031,0.19750008 6.46250001,0.000499999995 7.5,0 C8.53749999,0 9.51249969,0.197000071 10.4249997,0.59100008 C11.3374997,0.985000089 12.1312506,1.51925012 12.8062506,2.19375014 C13.4812506,2.86875013 14.0157495,3.66250026 14.4097495,4.57500029 C14.8037495,5.48750031 15.0005,6.46250001 15,7.5 C15,8.53749999 14.8029999,9.51249969 14.4089999,10.4249997 C14.0149999,11.3374997 13.4807506,12.1312506 12.8062506,12.8062506 C12.1312506,13.4812506 11.3374997,14.0157495 10.4249997,14.4097495 C9.51249969,14.8037495 8.53749999,15.0005 7.5,15 Z M7.5,13.5 C9.17500001,13.5 10.5937495,12.9187494 11.7562494,11.7562494 C12.9187494,10.5937495 13.5,9.17500001 13.5,7.5 C13.5,5.82499999 12.9187494,4.40624982 11.7562494,3.24374986 C10.5937495,2.08124989 9.17500001,1.5 7.5,1.5 C5.82499999,1.5 4.40624982,2.08124989 3.24374986,3.24374986 C2.08124989,4.40624982 1.5,5.82499999 1.5,7.5 C1.5,9.17500001 2.08124989,10.5937495 3.24374986,11.7562494 C4.40624982,12.9187494 5.82499999,13.5 7.5,13.5 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5, 5)",
    fill: "#0A186E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0963427324,3.21974424 L8.09634273,3.21974424 C8.52726609,3.21974424 8.87659849,3.56907664 8.87659849,4 C8.87659849,4.43092336 8.52726609,4.78025576 8.09634273,4.78025576 L-0.0963427324,4.78025576 C-0.527266089,4.78025576 -0.876598491,4.43092336 -0.876598491,4 C-0.876598491,3.56907664 -0.527266089,3.21974424 -0.0963427324,3.21974424 Z",
    id: "Rectangle",
    transform: "translate(4, 4) rotate(45) translate(-4, -4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0963427324,3.21974424 L8.09634273,3.21974424 C8.52726609,3.21974424 8.87659849,3.56907664 8.87659849,4 C8.87659849,4.43092336 8.52726609,4.78025576 8.09634273,4.78025576 L-0.0963427324,4.78025576 C-0.527266089,4.78025576 -0.876598491,4.43092336 -0.876598491,4 C-0.876598491,3.56907664 -0.527266089,3.21974424 -0.0963427324,3.21974424 Z",
    id: "Rectangle",
    transform: "translate(4, 4) rotate(135) translate(-4, -4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Disable.0c70df01e437b04c4a4e27eb0ff103e8.svg";